import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { of, switchMap } from 'rxjs';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const authService: AuthService = inject(AuthService);

    return inject(AuthService)
        .check()
        .pipe(
            switchMap((authenticated) => {
                if (!authenticated) {
                    authService.signOut();
                }

                return of(true);
            })
        );
};
